export default __webpack_public_path__ + "static/media/icon_arrow_down.b2a62d77.svg";